module.exports = __webpack_public_path__ + "static/media/sawi-hijau.b0f3b783.jpeg";